<div class="field">
    <mat-form-field
        [appearance]="appearance"
        [ngClass]="{'field-error': hasError}"
    >
    <mat-label [ngClass]="{'input-error' : hasError}">{{ label }}</mat-label>
    <input
        matInput
        (focus)="touched = true"
        (blur)="checkErrors($event)"
        [formControl]="control"
        [placeholder]="placeholder"       
        [required]="required"
        [type]="type"
        mask="00/00/0000"
        [dropSpecialCharacters]="false"
        [ngClass]="{'input-error' : hasError}"
    />
    <input
        matInput
        (focus)="touched = true"
        (blur)="checkErrors($event)"
        [hidden]="true"
        [formControl]="datePicker"
        [matDatepicker]="picker"
        [required]="required"
        [matDatepickerFilter]="dateFilterFn"
        [type]="inputType"
        [ngClass]="{'input-error' : hasError}"
    />
    <span matSuffix class="dob-suffix">
        <mat-datepicker-toggle
            [for]="picker"
            [disabled]="disableDatePicker || disabled"
        >
            <mat-icon
                matDatepickerToggleIcon
                [svgIcon]="iconUrl"
                aria-hidden="false"
                aria-label=""
            ></mat-icon>
        </mat-datepicker-toggle>
        <img *ngIf="showImage" class="dob-validation-img" [src]="image" />
    </span>
    <mat-datepicker
        #picker
        [disabled]="disableDatePicker"
        startView="month"
        [startAt]="startDate"
        (closed)="inputChanged()"
    ></mat-datepicker>
    <mat-error *ngIf="hasError" [innerHtml]="errorMessage"></mat-error>
    </mat-form-field>
</div>